if(process.env.NODE_ENV === 'production')
	console.log=function(){};
export const Log=console.log;
export const Warn=console.warn;
export const Error=console.error;